/**
 * @desc 保存/更新规则详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertRuleSaveRequest,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/web/alert/rule/saveAlertRule',
    data,
  });
}

export function mock(
  data: defs.AlertRuleSaveRequest,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/mock/web/alert/rule/saveAlertRule',
    data,
  });
}
